// extracted by css-extract-rspack-plugin
export default {"divider":"DashboardTodoListContentLayout_divider__tid22"};